"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var Check_base_1 = require("./Check.base");
var Check_styles_1 = require("./Check.styles");
exports.Check = Utilities_1.styled(Check_base_1.CheckBase, Check_styles_1.getStyles);
//# sourceMappingURL=Check.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/Check/Check.js
// module id = 880
// module chunks = 0